<div class="form-group-query">
    <div [style]="props['labelstyle']">
        <label>{{to.label}}</label>
    </div>
    <div style="margin-left:10px">
        <input [checked]="isChecked" (change)="onCheckboxChange($event)" type="checkbox" />
    </div>
    <div style="margin-left:10px">
        <p-calendar [(ngModel)]="date" appendTo="body" [view]="calendarView" (onSelect)="onSelect($event)"
            dataType="string"  [dateFormat]="dateFormat" [formControl]="formControl" [inputStyle]="style"
            [formlyAttributes]="field" (ngModelChange)="updateCheckbox()">
        </p-calendar>
    </div>
</div>